<template>
  <div class="mt-3">
    <h2 class="fw-bold text-teal">Área Administrativa</h2>
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-3">
        <router-link
          to="/admin/orcamentos"
          title="Gestão de Período de Orçamento"
        >
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Orçamentos</h5>
              <i class="ph-calendar ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-lg-4 col-md-6 mb-3">
        <router-link to="/admin/sincronizacoes" title="Sincronizações de Dados">
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Sincronizações</h5>
              <i class="ph-arrows-clockwise ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-lg-4 col-md-6 mb-3">
        <router-link
          to="/admin/centros-custos-bloqueados"
          title="Centros de Custos Bloqueados"
        >
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">
                Centros de Custos Bloqueado
              </h5>
              <i class="ph-lock ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-lg-4 col-md-6 mb-3">
        <router-link
          to="/admin/usuarios-permissao"
          title="Usuários com Permissão"
        >
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Usuários com Permissão</h5>
              <i class="ph-user-gear ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-lg-4 col-md-6 mb-3">
        <router-link to="/admin/importacao" title="Importação">
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Importação</h5>
              <i class="ph-upload ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Admin',
}
</script>
